import { Navbar1 } from "components/navbars";
import { Footer1 } from "components/footer";
import Seo from "components/Seo";
import BackToTop from "components/BackToTop";


import TermsAndCondition from "crm/other/TermsCondition";

export default function TermsAndConditions() {
    return (
        <>
            {/* <Seo pageName="features" /> */}

            {/* <Navbar1 /> */}
            <TermsAndCondition />
            <Footer1 />
            <BackToTop />
        </>
    );
}
